/* Quét theo việc — màn kho cho máy quét / điện thoại (18/09/2026, 0088). */
export const scanTasksEn = {
  scan: {
    tabTasks: "Scan by task", tabDevices: "Device test",
    intro: "Use a handheld scanner (it types the code and presses Enter) or the phone camera. One screen per job: scan, check, press one button.",
    tasks: { lookup: "Look up lot", receive: "Receive", move: "Put away / move", pick: "Ship by delivery note", count: "Count" },
    go: "Find", camera: "Scan with camera", cameraTitle: "Scan with camera", cameraHint: "Hold the barcode inside the frame.",
    cameraError: "Could not open the camera. Allow the browser to use it, or use a scanner.",
    parseError: "Could not read the code: {{code}}", failed: "That did not work — try again, or tell an administrator.", reset: "Start again", loading: "Loading…",
    scanLot: "Scan lot label", scanLotPlaceholder: "LOT:… or lot number",
    lotNotFound: "Lot {{lot}} is not in any warehouse.",
    qty: { onHand: "In warehouse", available: "Usable", pending: "Pending / in transit", rejected: "Rejected", reserved: "Reserved" },
    openStock: "Open product stock",
    move: {
      choose: "This lot is in several locations — choose where to take it from.", noAvailable: "This lot has no usable stock to move.",
      from: "From", toWarehouse: "To warehouse", toLocation: "New location (scan or type)", quantity: "Quantity", reason: "Reason", reasonDefault: "Put away on the shelf",
      submit: "Move", done: "Moved {{qty}} {{unit}} from {{from}} to {{to}} (transfer {{no}}).",
      shipped: "Sent {{qty}} {{unit}} to {{warehouse}} (transfer {{no}}). The receiving warehouse confirms receipt on the Lot transfers page.",
      draftOnly: "Draft transfer {{no}} created but not finished: finishing a move needs Edit on Stock movements.",
    },
    pick: {
      scanDn: "Scan or type the delivery note number", dnPlaceholder: "Delivery note no.", notFound: "No delivery note {{no}} waiting to ship.",
      notPending: "{{no}} is {{status}} — only notes waiting to ship can be issued here.",
      needSource: "No source yet", fromLot: "From lot {{lot}} · {{warehouse}} {{location}}", direct: "Direct", directShort: "Direct: {{note}}",
      directNote: "Direct note (who ships it)", noStock: "Not in stock — direct only",
      lotNoMatch: "Lot {{lot}} does not match any line that still needs goods (wrong item, unit or lot, or not enough usable stock).",
      scanHint: "Scan the lot label of the goods you take for each line. Lines without stock are shipped direct with a note.",
      choose: "Lot {{lot}} fits several lines or locations — choose the goods you just took.", lineNo: "Line {{n}}",
      remaining: "{{n}} line(s) still without a source.", submit: "Issue stock & mark In transit",
      done: "{{no}} is now In transit; stock was issued from the scanned lots.",
    },
    count: {
      warehouse: "Warehouse", scanned: "Counted lots", system: "Book", counted: "Counted", variance: "Difference", varianceReason: "Reason for difference",
      notInWarehouse: "Lot {{lot}} is not in this warehouse.", choose: "Lot {{lot}} is in several places here (another item or another location) — choose the one you are counting.",
      enter: "Count for {{lot}} at {{location}}", add: "Record count", reason: "Reason", reasonDefault: "Lot count with the scanner",
      submit: "Create count and send for posting", done: "Created {{no}} and sent it for posting — someone with Approve on Stock movements posts it on the Counts page.",
      saveDraft: "Create count (draft)", draftHint: "Sending a count for posting needs Edit on Stock movements: this screen creates a draft count.",
      draftOnly: "Created draft count {{no}}. Someone with the Stock movements ticks sends and posts it on the Counts page.",
      varianceRequired: "Give a reason (at least 5 characters) for each line whose count differs from the book.",
      empty: "Scan the first lot label to start.",
    },
    receive: {
      scanPo: "Scan or type the purchase order number", poPlaceholder: "Purchase order no.", notFound: "No purchase order {{no}} waiting to be received.",
      warehouse: "Warehouse", date: "Received date", deliveryNote: "Supplier delivery note no.", remaining: "Remaining",
      quantity: "Received", lot: "Lot number", location: "Location", submit: "Create receipt & confirm",
      done: "Received into stock: {{no}}. Print the lot labels and stick them on the goods.",
      draftOnly: "Draft receipt {{no}} created; confirming it needs Approve on Warehouse & LOT.",
      needDeliveryNote: "Enter the supplier's delivery note number.", nothing: "Enter a received quantity on at least one line.",
      badQuantity: "Received quantity not understood for {{codes}}: use digits with a dot for decimals, no thousands separators (e.g. 1250 or 12.5).",
      saveDraft: "Create receipt (draft)", draftHint: "Confirming a receipt needs Approve on Warehouse & LOT: this screen creates a draft for an approver.",
    },
  },
};
export const scanTasksVi = {
  scan: {
    tabTasks: "Quét theo việc", tabDevices: "Kiểm thiết bị",
    intro: "Dùng máy quét cầm tay (quét ra chữ rồi tự Enter) hoặc camera điện thoại. Mỗi việc một màn: quét, kiểm, bấm một nút.",
    tasks: { lookup: "Tra lô", receive: "Nhận hàng", move: "Cất / chuyển", pick: "Xuất theo phiếu giao", count: "Kiểm kê" },
    go: "Tìm", camera: "Quét bằng camera", cameraTitle: "Quét bằng camera", cameraHint: "Đưa mã vạch vào giữa khung hình.",
    cameraError: "Không mở được camera. Cho phép trình duyệt dùng camera, hoặc dùng máy quét.",
    parseError: "Không đọc được mã: {{code}}", failed: "Không làm được — thử lại, hoặc báo quản trị viên.", reset: "Làm lại", loading: "Đang tải…",
    scanLot: "Quét tem lô", scanLotPlaceholder: "LOT:… hoặc số lô",
    lotNotFound: "Không có lô {{lot}} trong kho nào.",
    qty: { onHand: "Trong kho", available: "Dùng được", pending: "Chờ kiểm / đang chuyển", rejected: "Không đạt", reserved: "Đang giữ chỗ" },
    openStock: "Mở tồn kho sản phẩm",
    move: {
      choose: "Lô này nằm ở nhiều vị trí — chọn chỗ lấy hàng.", noAvailable: "Lô này không còn hàng dùng được để chuyển.",
      from: "Lấy từ", toWarehouse: "Sang kho", toLocation: "Vị trí mới (quét hoặc gõ)", quantity: "Số lượng", reason: "Lý do", reasonDefault: "Cất hàng lên kệ",
      submit: "Chuyển", done: "Đã chuyển {{qty}} {{unit}} từ {{from}} sang {{to}} (phiếu {{no}}).",
      shipped: "Đã gửi {{qty}} {{unit}} sang {{warehouse}} (phiếu {{no}}). Kho nhận xác nhận ở trang Chuyển lô.",
      draftOnly: "Đã lập phiếu nháp {{no}} nhưng chưa chốt được: chốt chuyển cần ô Sửa ở Biến động kho.",
    },
    pick: {
      scanDn: "Quét hoặc gõ số phiếu giao", dnPlaceholder: "Số phiếu giao", notFound: "Không có phiếu giao {{no}} đang chờ giao.",
      notPending: "Phiếu {{no}} đang {{status}} — ở đây chỉ xuất kho phiếu đang chờ giao.",
      needSource: "Chưa có nguồn", fromLot: "Xuất từ lô {{lot}} · {{warehouse}} {{location}}", direct: "Giao thẳng", directShort: "Giao thẳng: {{note}}",
      directNote: "Ghi chú giao thẳng (ai giao)", noStock: "Kho không có — chỉ giao thẳng",
      lotNoMatch: "Lô {{lot}} không khớp dòng nào còn cần hàng (sai mã, đơn vị, lô, hoặc không đủ hàng xuất bán được).",
      scanHint: "Quét tem lô của hàng lấy cho từng dòng. Dòng kho không có hàng thì giao thẳng, ghi chú.",
      choose: "Lô {{lot}} khớp nhiều dòng hoặc nhiều vị trí — chọn đúng hàng vừa lấy.", lineNo: "Dòng {{n}}",
      remaining: "Còn {{n}} dòng chưa có nguồn.", submit: "Xuất kho & chuyển Đang giao",
      done: "{{no}} đã chuyển Đang giao; tồn đã trừ theo các lô vừa quét.",
    },
    count: {
      warehouse: "Kho", scanned: "Lô đã đếm", system: "Sổ", counted: "Đếm", variance: "Chênh", varianceReason: "Lý do chênh",
      notInWarehouse: "Lô {{lot}} không có trong kho này.", choose: "Lô {{lot}} có ở nhiều chỗ trong kho này (khác mã hàng hoặc khác vị trí) — chọn đúng chỗ đang đếm.",
      enter: "Số đếm của {{lot}} tại {{location}}", add: "Ghi số đếm", reason: "Lý do", reasonDefault: "Kiểm kê theo lô bằng máy quét",
      submit: "Lập phiếu kiểm kê và gửi chờ ghi sổ", done: "Đã lập {{no}} và gửi chờ ghi sổ — người có ô Duyệt ở Biến động kho ghi sổ ở trang Kiểm kê.",
      saveDraft: "Lập phiếu kiểm kê (nháp)", draftHint: "Gửi phiếu kiểm kê chờ ghi sổ cần ô Sửa ở Biến động kho: màn này lập phiếu nháp.",
      draftOnly: "Đã lập phiếu kiểm kê nháp {{no}}. Người có ô tick ở Biến động kho gửi và ghi sổ ở trang Kiểm kê.",
      varianceRequired: "Dòng nào số đếm khác sổ thì ghi lý do (ít nhất 5 ký tự).",
      empty: "Quét tem lô đầu tiên để bắt đầu.",
    },
    receive: {
      scanPo: "Quét hoặc gõ số đơn mua", poPlaceholder: "Số đơn mua", notFound: "Không có đơn mua {{no}} đang chờ nhận hàng.",
      warehouse: "Kho", date: "Ngày nhận", deliveryNote: "Số phiếu giao của nhà cung cấp", remaining: "Còn lại",
      quantity: "Số nhận", lot: "Số lô", location: "Vị trí", submit: "Lập phiếu nhập & xác nhận",
      done: "Đã nhập kho {{no}}. In tem lô để dán lên hàng.",
      draftOnly: "Đã lập phiếu nhập nháp {{no}}; xác nhận cần quyền Duyệt ở Kho & LOT.",
      needDeliveryNote: "Nhập số phiếu giao của nhà cung cấp.", nothing: "Nhập số nhận ở ít nhất một dòng.",
      badQuantity: "Số nhận chưa đúng ở {{codes}}: chỉ gõ chữ số, dùng dấu chấm cho phần lẻ, không dấu phân cách hàng nghìn (ví dụ 1250 hoặc 12.5).",
      saveDraft: "Lập phiếu nhập (nháp)", draftHint: "Xác nhận nhập kho cần quyền Duyệt ở Kho & LOT: màn này lập phiếu nháp chờ người duyệt.",
    },
  },
};
export const scanTasksZh = {
  scan: {
    tabTasks: "依作业扫描", tabDevices: "设备测试",
    intro: "使用手持扫描枪（扫描后自动按 Enter）或手机相机。每项作业一个页面：扫描、核对、按一个按钮。",
    tasks: { lookup: "查询批次", receive: "收货", move: "上架／移位", pick: "依送货单出库", count: "盘点" },
    go: "查询", camera: "用相机扫描", cameraTitle: "用相机扫描", cameraHint: "将条码置于画面中央。",
    cameraError: "无法打开相机。请允许浏览器使用相机，或改用扫描枪。",
    parseError: "无法读取条码：{{code}}", failed: "无法完成——请重试，或通知管理员。", reset: "重新开始", loading: "加载中…",
    scanLot: "扫描批次标签", scanLotPlaceholder: "LOT:… 或批号",
    lotNotFound: "任何仓库都没有批次 {{lot}}。",
    qty: { onHand: "在库", available: "可用", pending: "待检／调拨中", rejected: "不合格", reserved: "已预留" },
    openStock: "打开产品库存",
    move: {
      choose: "此批次位于多个库位——请选择取货库位。", noAvailable: "此批次没有可移动的可用库存。",
      from: "取自", toWarehouse: "移至仓库", toLocation: "新库位（扫描或输入）", quantity: "数量", reason: "原因", reasonDefault: "将货物放上货架",
      submit: "移动", done: "已将 {{qty}} {{unit}} 从 {{from}} 移至 {{to}}（调拨单 {{no}}）。",
      shipped: "已发出 {{qty}} {{unit}} 至 {{warehouse}}（调拨单 {{no}}）。收货仓库于“批次调拨”页确认收货。",
      draftOnly: "已创建调拨草稿 {{no}}，但未能完成：完成移动需要“库存变动”的“编辑”勾选。",
    },
    pick: {
      scanDn: "扫描或输入送货单号", dnPlaceholder: "送货单号", notFound: "没有待出货的送货单 {{no}}。",
      notPending: "{{no}} 目前为 {{status}}——此处只能出库待出货的送货单。",
      needSource: "尚无货源", fromLot: "由批次 {{lot}} 出库 · {{warehouse}} {{location}}", direct: "直送", directShort: "直送：{{note}}",
      directNote: "直送备注（由谁出货）", noStock: "无库存——只能直送",
      lotNoMatch: "批次 {{lot}} 不符合任何仍需货物的明细（品号、单位或批号不符，或可出库数量不足）。",
      scanHint: "为每条明细扫描所取货物的批次标签。无库存的明细以直送处理并填写备注。",
      choose: "批次 {{lot}} 符合多条明细或多个库位——请选择刚取的货物。", lineNo: "第 {{n}} 行",
      remaining: "尚有 {{n}} 条明细没有货源。", submit: "出库并标记运送中",
      done: "{{no}} 已标记为运送中；已依扫描的批次扣减库存。",
    },
    count: {
      warehouse: "仓库", scanned: "已盘点批次", system: "账面", counted: "盘点", variance: "差异", varianceReason: "差异原因",
      notInWarehouse: "此仓库没有批次 {{lot}}。", choose: "批次 {{lot}} 在此仓库有多处（不同品号或不同库位）——请选择正在盘点的位置。",
      enter: "{{lot}} 在 {{location}} 的盘点数", add: "记录盘点数", reason: "原因", reasonDefault: "以扫描枪依批次盘点",
      submit: "创建盘点单并提交待过账", done: "已创建 {{no}} 并提交待过账——由具备“库存变动”审核勾选的人在“盘点”页过账。",
      saveDraft: "创建盘点单（草稿）", draftHint: "提交盘点单待过账需要“库存变动”的“编辑”勾选：此页面创建草稿。",
      draftOnly: "已创建盘点单草稿 {{no}}。由具备“库存变动”勾选的人在“盘点”页提交并过账。",
      varianceRequired: "盘点数与账面不同的明细请填写原因（至少 5 个字符）。",
      empty: "扫描第一个批次标签即可开始。",
    },
    receive: {
      scanPo: "扫描或输入采购单号", poPlaceholder: "采购单号", notFound: "没有待收货的采购单 {{no}}。",
      warehouse: "仓库", date: "收货日期", deliveryNote: "供应商送货单号", remaining: "剩余",
      quantity: "实收", lot: "批号", location: "库位", submit: "创建入库单并确认",
      done: "已入库：{{no}}。请打印批次标签并贴在货物上。",
      draftOnly: "已创建入库单草稿 {{no}}；确认需要“仓库与批次”的审核权限。",
      needDeliveryNote: "请输入供应商送货单号。", nothing: "请至少在一条明细输入实收数量。",
      badQuantity: "{{codes}} 的实收数量格式不正确：只输入数字，小数用点，不加千位分隔符（例如 1250 或 12.5）。",
      saveDraft: "创建入库单（草稿）", draftHint: "确认入库需要“仓库与批次”的审核权限：此页面创建草稿，待审核人确认。",
    },
  },
};
